



























































































































// import Element from 'element-ui'
import { Component, Vue, Watch } from 'vue-property-decorator'
import {
  viewInfo, CruiseMakeupData, CruiseMakeupDetailData, emptyCruiseMakeup
} from '@/api/heritageCruise/cruiseMakeup'
import multiFile from '@/components/upload/multiFile.vue'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import ViewDialog from '@/components/dialog/viewDialog.vue'
import viewLink from '@/components/viewLink.vue'

@Component({
  components: { ViewDialog, viewLink, multiFile }
})
export default class CruiseMakeupView extends Vue {
  public expandNames: string[] = ['base', 'action']
  public showDialog: boolean = false
  public loading: boolean = false

  public form: CruiseMakeupData = emptyCruiseMakeup
  public $refs!: {}
  public hasFile: boolean = true
  public onFileChange(data: { opts: UploadOptData; files: AttachInfo[] }) {
    const list = data.files
    this.hasFile = list.length > 0
  }
  public expandKeys: number[] = []
  public expandClass(id: number): string {
    if (this.expandKeys.findIndex(v => v == id) > -1) {
      return 'el-icon-arrow-down'
    }
    else {
      return 'el-icon-arrow-right'
    }
  }
  public rowExpand(row: CruiseMakeupDetailData, event: any, column: any) {
    const f = this.form
    const pointId = row.HeritageCruisePointId
    const keyIndex = this.expandKeys.findIndex(v => v == pointId)
    if (keyIndex < 0) {
      //展开，查询子级
      this.expandKeys.push(pointId)
    } else {
      // 移除展开项      
      this.expandKeys.splice(keyIndex, 1)
    }
  }

  public created() { }
  public mounted() {
    window.eventBus.$on('viewCruiseMakeup', (id: number) => {
      this.showDialog = true
      this.fetchData(id)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off('viewCruiseMakeup')
  }
  public closeDialog() {
    this.showDialog = false
  }
  public fetchData(id: number) {
    this.loading = true
    viewInfo(id).then((response: { data: any }) => {
      this.form = response.data
      this.form.DetailList.forEach((e: CruiseMakeupDetailData) => {
        if (e.SubList && e.SubList.length > 0) {
          this.expandKeys.push(e.HeritageCruisePointId)
          // this.rowExpand(e, null, null)
        }
      })
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
}
